<template>
	<svg :width="props.width" :height="props.height" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M8.16797 3.5H19.8346V8.16667C19.8346 11.3883 17.223 14 14.0013 14C10.7796 14 8.16797 11.3883 8.16797 8.16667V3.5Z"
			:fill="props.iconColor"
		/>
		<path
			d="M19.832 24.5L8.16537 24.5L8.16537 19.8333C8.16537 16.6117 10.777 14 13.9987 14C17.2204 14 19.832 16.6117 19.832 19.8333L19.832 24.5Z"
			:fill="props.iconColor"
		/>
		<path d="M7 24.5H21" :stroke="props.iconColor" stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round" />
		<path d="M7 3.5H21" :stroke="props.iconColor" stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round" />
	</svg>
</template>
<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		width?: string | number;
		height?: string | number;
		iconColor?: string;
	}>(),
	{
		width: 28,
		height: 28,
		iconColor: '#ffff',
	}
);
</script>

<style lang="scss" scoped></style>
